export default "__VITE_ASSET__CiDrHfNI__"